const NextStep = function(location, nextStepAction) {
  this.location = location
  this.complete = function(args){
    if (nextStepAction!==undefined)
      return nextStepAction(args)
  }
}

export default NextStep


/** WEBPACK FOOTER **
 ** ./components/utils/next-step.js
 **/